import React from 'react';
import Section from '../../../Components/Containers/Section';

const NoData = ({title, subtitle}) => {
    return <Section title={title} subtitle={subtitle}>
        <div className="flex items-center justify-center h-40 border-dashed border-2 rounded-xl border-gray-300">
            <p className="text-muted text-center">No data available</p>
        </div>
    </Section>
}

export default NoData;